export const CONTRACT_CELL_WIDTH = {
    contract: 130,
    pricing: 100,
    size: 80,
    start: 150,
    end: 150,
    package: 120,
    integration: 120,
};
